<template>
  <div class="background"
       :style="backImg"
       :class="fullscreen">
    <div style="text-align: center; height: 8vh; position: relative">
      <div>
        <img style="width: 100%"
             src="../../../assets/icon/facility/top.png"
             alt="" />
      </div>
      <div class="topTit">
        <span class="mouse"
              @click="getAll">TPM&Andon看板</span>
      </div>
      <div class="topTime">
        <span style="margin-right: 10px">{{ date | formaDate }}</span>
        <div>
          <div @click="fullscreens()"
               v-show="full === true">
            <img class="mouse"
                 style="width: 1.5vw; height: 1.5vw"
                 src="../../../assets/icon/全屏.png"
                 alt="" />
          </div>
          <div @click="fullscreens2()"
               v-show="full === false">
            <img class="mouse"
                 style="width: 1.8vw; height: 1.8vw"
                 src="../../../assets/icon/缩小.png"
                 alt="" />
          </div>
        </div>
      </div>
    </div>
    <div style="display: flex; width: 100%; height: 65vh">
      <div class="shopoVerall">
        <div style="display: flex; width: 100%; height: 9%; justify-content: space-between">
          <div style="align-items: center; position: relative">
            <div>
              <img style="width: 77%; margin: 10px"
                   src="../../../assets/icon/facility/标题背景.png"
                   alt="" />
            </div>
            <div>
              <span class="shopTit">车间布局图</span>
            </div>
          </div>
          <div class="explain">
            <div>
              <img src="../../../assets/icon/facility/调试故障.png"
                   alt="" />
              <span style="color: #5491F8">调试&故障</span>
            </div>
            <!--<div>
                            <img src="../../../assets/icon/facility/形状 1 拷贝 2.png" alt=""/>
                            <span style="color: red">故障</span>
                        </div>-->
            <div>
              <img src="../../../assets/icon/facility/质量故障.png"
                   alt="" />
              <span style="color: red">质量故障</span>
            </div>
            <div>
              <img src="../../../assets/icon/facility/物流故障.png"
                   alt="" />
              <span style="color: #c5ae76">物流故障</span>
            </div>
            <div>
              <img src="../../../assets/icon/facility/闲置中.png"
                   alt="" />
              <span style="color: #2bbea3">运行</span>
            </div>
            <div>
              <img src="../../../assets/icon/facility/停机中.png"
                   alt="" />
              <span style="color: #b7b5bc">计划停机</span>
            </div>
          </div>
        </div>
        <div class="shoplayout">
          <div v-for="(item, index) in shoplayoutInfo"
               :key="`chejian${item.deptID}`"
               class="layout">
            <div style="width: 13vw">
              <p style="margin-left: 1.5vw"
                 v-if="index == 0">工厂</p>
              <div style="width: 100%; display: flex; margin-top: 0.2vw; height: 100%; align-items: center">
                <div :class="{
                                    shopBorder: activeShop === item.deptCode
                                }"
                     @click="plantCodeInfo(item.deptCode)"
                     class="plantName">
                  {{ item.deptName }}
                </div>
                <img style="margin-left: 0.5vw; margin-top: -0.5vw"
                     src="../../../assets/icon/facility/工厂.png"
                     alt="" />
              </div>
            </div>
            <div style="margin-left: 0.5vw; width: 12vw">
              <p v-if="index == 0">车间</p>
              <div class="shopInfo"
                   @mousewheel="handleScroll"
                   style="width: 100%"
                   :class="{
                                shopBor: index + 1 != length,
                                shopHei3: length2 === 3,
                                shopHei4: length2 === 4,
                                shopHei6: length2 === 6,
                                shopHei9: length2 === 9
                            }">
                <div v-for="(shopLine, shopindex) in item.shopChild"
                     :key="shopindex"
                     style="">
                  <div v-for="(shopName, Nameindex) in shopLine"
                       :key="Nameindex">
                    <div v-if="shopName.deptCode != null"
                         :class="{
                                            shopBgColor1: shopName.inIdleFlag === true,
                                            shopBgColor2: shopName.inRunFlag === true,
                                            shopBgColor1: shopName.inFaultFlag === true,
                                            shopBgColor3: shopName.inQualityFailure === true,
                                            shopBgColor5: shopName.inLogisticsFailure === true,
                                            shopBgColor4: shopName.inHaltFlag === true,
                                            shopName: true,
                                            shopBorder: activeShop === shopName.deptCode
                                        }"
                         @click="shopCodeInfo(shopName.deptCode, item.deptCode)">
                      {{ shopName.deptName }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-left: 1vw; width: 16vw">
              <p v-if="index == 0">工段</p>
              <div class="shopInfo"
                   @mousewheel="handleScroll"
                   style="width: 100%"
                   :class="{
                                shopBor: index + 1 != length,
                                shopHei3: length2 === 3,
                                shopHei4: length2 === 4,
                                shopHei6: length2 === 6,
                                shopHei9: length2 === 9
                            }">
                <div v-for="(shopLine, shopindex) in item.sectionChild"
                     :key="shopindex"
                     style="">
                  <div v-for="(shopName, Nameindex) in shopLine"
                       :key="Nameindex">
                    <div v-if="shopName.deptCode != null"
                         :class="{
                                            shopBgColor1: shopName.inIdleFlag === true,
                                            shopBgColor2: shopName.inRunFlag === true,
                                            shopBgColor1: shopName.inFaultFlag === true,
                                            shopBgColor3: shopName.inQualityFailure === true,
                                            shopBgColor5: shopName.inLogisticsFailure === true,
                                            shopBgColor4: shopName.inHaltFlag === true,
                                            shopName: true,
                                            shopBorder: activeShop === shopName.deptCode
                                        }"
                         @click="sectionCodeInfo(shopName.deptCode, item.deptCode)">
                      {{ shopName.deptName }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-left: 1vw; width: 16vw">
              <p v-if="index == 0">产线</p>
              <div class="shopInfo"
                   @mousewheel="handleScroll"
                   style="width: 100%"
                   :class="{
                                shopBor: index + 1 != length,
                                shopHei3: length2 === 3,
                                shopHei4: length2 === 4,
                                shopHei6: length2 === 6,
                                shopHei9: length2 === 9
                            }">
                <div v-for="(shopLine, shopindex) in item.lineChild"
                     :key="shopindex"
                     style="">
                  <div v-for="(shopName, Nameindex) in shopLine"
                       :key="Nameindex">
                    <div v-if="shopName.deptCode != null"
                         :class="{
                                            shopBgColor1: shopName.inIdleFlag === true,
                                            shopBgColor2: shopName.inRunFlag === true,
                                            shopBgColor1: shopName.inFaultFlag === true,
                                            shopBgColor3: shopName.inQualityFailure === true,
                                            shopBgColor5: shopName.inLogisticsFailure === true,
                                            shopBgColor4: shopName.inHaltFlag === true,
                                            shopName: true,
                                            shopBorder: activeShop === shopName.deptCode
                                        }"
                         @click="lineCodeInfo(shopName.deptCode, item.deptCode)">
                      {{ shopName.deptName }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div style="margin-left: 1vw; width: 16vw">
              <p v-if="index == 0">设备</p>
              <div class="shopInfo"
                   @mousewheel="handleScroll"
                   style="width: 100%"
                   :class="{
                                shopBor: index + 1 != length,
                                shopHei3: length2 === 3,
                                shopHei4: length2 === 4,
                                shopHei6: length2 === 6,
                                shopHei9: length2 === 9
                            }">
                <div v-for="(shopLine, shopindex) in item.deviceChild"
                     :key="shopindex"
                     style="">
                  <div v-for="(shopName, Nameindex) in shopLine"
                       :key="Nameindex">
                    <div v-if="shopName.devCode != null"
                         :class="{
                                            shopBgColor1: shopName.devRunStatus.code === 'in_idle',
                                            shopBgColor2: shopName.devRunStatus.code === 'in_run',
                                            shopBgColor1: shopName.devRunStatus.code === 'in_fault',
                                            shopBgColor3: shopName.devRunStatus.code === 'in_quality',
                                            shopBgColor5: shopName.devRunStatus.code === 'in_logistics',
                                            shopBgColor4: shopName.devRunStatus.code === 'in_halt',
                                            shopName: true,
                                            shopBorder: activeShop === shopName.deptCode
                                        }"
                         @click="devCodeInfo(shopName.deptCode, item.deptCode)">
                      {{ shopName.devName }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="echarState">
        <div style="position: relative; display: flex">
          <div>
            <img style="width: 92%; height: 30px; margin-left: 10px; margin-top: 10px"
                 src="../../../assets/icon/facility/标题背景.png"
                 alt="" />
          </div>
          <div class="lineState">产线状态</div>
        </div>
        <stateCake v-bind:shopInfo="shopBeg"
                   style="width: 100%; height: 35%"></stateCake>
        <div class="equiinfo"
             style="margin-top: 5px; border-top: 1px solid #ccc; width: 100%; height: 35%">
          <div style="display: flex; font-size: 12px; background-color: rgb(42, 102, 165); color: #fff; height: 23%; align-items: center"
               @click="getAndonOrder">
            <span style="width: 33%; text-align: center">报修状态</span>
            <span style="width: 33%; text-align: center">报修内容</span>
            <!--<span style="width: 20%; text-align: center">所属车间</span>-->
            <span style="width: 33%; text-align: center">报修时间</span>
            <!--<span style="width: 25%; text-align: center">等待时间</span>-->
          </div>
          <div style="display: flex; height: 37%; border-bottom: 1px #ccc solid; width: 100%">
            <div style="width: 30%; display: flex; justify-content: center; align-items: center">
              <div style="color: #e13e43; margin-bottom: 5px">
                <p style="font-size: 2vw; margin-top: 0vw; display: flex; justify-content: center">{{
                                    tableData.length }}</p>
                <p style="font-size: 0.8vw; display: flex; justify-content: center">待接单</p>
              </div>
            </div>
            <div style="width: 70%; overflow: auto">
              <div v-for="(item, index) in tableData"
                   :key="index"
                   class="repair">
                <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
                  {{ item.andonProbDesc }}
                </div>
                <!--<div>{{ item.shopName }}</div>-->
                <div>{{ item.createTime | moment('MM/DD HH:mm') }}</div>
                <!--<van-count-down :time="item.countDown" />-->
              </div>
            </div>
          </div>
          <div style="display: flex; height: 37%; border-bottom: 1px #ccc solid; width: 100%">
            <div style="width: 30%; display: flex; justify-content: center; align-items: center">
              <div style="color: #ffbf44; margin-bottom: 5px">
                <p style="font-size: 2vw; margin-top: 0vw; display: flex; justify-content: center">{{
                                    tableWaitData.length }}</p>
                <p style="font-size: 0.8vw; display: flex; justify-content: center">待完成</p>
              </div>
            </div>
            <div style="width: 70%; overflow: auto">
              <div v-for="(item, index) in tableWaitData"
                   :key="index"
                   class="repair">
                <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">{{
                                    item.andonProbDesc }}
                </div>
                <!--<div>{{ item.shopName }}</div>-->
                <div>{{ item.createTime | moment('MM/DD HH:mm') }}</div>
                <!--<van-count-down :time="item.countDown" />-->
              </div>
            </div>
          </div>
        </div>
        <div style="display: flex; color: #fff; margin-top: 1vw; width: 100%; align-items: center; font-size: 0.8vw"
             class="Sty1">
          <div style="flex: 1; text-align: center">
            <p>当月总共单数</p>
            <p>(当月)</p>
            <h3 style="margin-top: 10px">{{ searchData.averageTaking }}</h3>
          </div>
          <div style="flex: 1; text-align: center">
            <p>平均响应时间</p>
            <p>(当月)</p>
            <h3 style="margin-top: 10px">{{ searchData.averageResponseTime }}(分)</h3>
          </div>
          <div style="flex: 1; text-align: center">
            <p>平均修复时间</p>
            <p>(当月)</p>
            <h3 style="margin-top: 10px">{{ searchData.averageRepairTime }}(分)</h3>
          </div>
        </div>
      </div>
    </div>
    <div class="echarInfo">
      <div class="vessel">
        <div class="TItexplain">
          <img src="../../../assets/icon/facility/标题背景.png"
               alt=""
               @click="getSignNumber" />
          <div class="Signed">
            <span>维修人数</span>
          </div>
        </div>
        <signNumber v-bind:shopInfo="shopBeg"
                    class="signNumber"></signNumber>
      </div>
      <div class="vessel">
        <div class="TItexplain">
          <img src="../../../assets/icon/facility/标题背景.png"
               alt=""
               @click="getDeviceStatus" />
          <div class="Signed">
            <span>设备状态</span>
          </div>
        </div>
        <equiState v-bind:shopInfo="shopBeg"
                   class="equiState"></equiState>
      </div>
      <div class="vessel">
        <div class="TItexplain">
          <img src="../../../assets/icon/facility/标题背景.png"
               alt=""
               @click="getAndonStatus" />
          <div class="Signed">
            <span>安灯状态</span>
          </div>
        </div>
        <andonState v-bind:shopInfo="shopBeg"
                    class="andonState"></andonState>
      </div>
      <div class="vessel">
        <div class="TItexplain">
          <img src="../../../assets/icon/facility/标题背景.png"
               alt=""
               @click="getAndonTypes" />
          <div class="Signed">
            <span>安灯类型</span>
          </div>
        </div>
        <andonType v-bind:shopInfo="shopBeg"
                   class="andonType"></andonType>
      </div>
      <div class="vessel">
        <div class="TItexplain">
          <img src="../../../assets/icon/facility/标题背景.png"
               alt=""
               @click="getPlanMain" />
          <div class="Signed">
            <span>保养统计</span>
          </div>
        </div>
        <upkeepState v-bind:shopInfo="shopBeg"
                     class="upkeepState"></upkeepState>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import moment from 'moment'
import stateCake from '../../../components/echarSpectaculars/handleScroll.vue'
import signNumber from '../../../components/echarSpectaculars/signNumber.vue'
import equiState from '../../../components/echarSpectaculars/equiState.vue'
import andonState from '../../../components/echarSpectaculars/andonState.vue'
import andonType from '../../../components/echarSpectaculars/andonType.vue'
import upkeepState from '../../../components/echarSpectaculars/upkeepState.vue'
import { personnelFacTotality } from '../../../libs/api'
//创建一个函数来增加月日时小于10在前面加0
var padaDate = function (value) {
  return value < 10 ? '0' + value : value
}
export default {
  components: {
    stateCake,
    signNumber,
    equiState,
    andonState,
    andonType,
    upkeepState
  },
  data () {
    return {
      length: 6,
      length2: 0,
      fullscreen: '',
      shopBeg: {
        fcCode: '',
        fcCodes: '',
        shopCode: '',
        sectionCode: '',
        lineCode: ''
      },
      tableData: [],
      tableWaitData: [],

      searchData: {
        averageRepairTime: 0,//平均故障修复时长
        averageResponseTime: 0,//平均故障响应时长
        averageTaking: 0//当月总共单数
      },
      intervalId: null,
      date: new Date(), //实时时间
      shoplayoutInfo: [],
      shopChild: [],
      shopBor: 'shopBor',
      full: true,
      backImg: {
        backgroundImage: 'url(' + require('../../../assets/icon/facility/背景.png') + ')',
        backgroundRepeat: 'no-repeat'
      },
      activeShop: 0,
      fullRec: '',
      userInfo: {}
    }
  },
  created () {
    this.dataRefreh()
  },
  mounted () {
    this.fullRec = ''
    this.fullRec = this.$route.params.full
    if (this.fullRec) {
      if (this.fullscreen == '') {
        this.fullscreen = 'fullscreen',
          this.full = false
        this.deptShow = false
        let docElm = document.documentElement
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen()
        } else if (docElm.msRequestFullscreen) {
          docElm.msRequestFullscreen()
        } else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen()
        } else if (docElm.webkitRequestFullScreen) {
          docElm.webkitRequestFullScreen()
        }
      }
    }
    if (window.sessionStorage.getItem('userInfo')) {
      let userinfo = JSON.parse(window.sessionStorage.getItem('userInfo'))
      this.userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'))
      let List = []
      if (userinfo.factoryId == 0) {
        this.$set(this.shopBeg, 'fcCodes', '')
        this.$set(this.shopBeg, 'fcCode', '')
      } else {
        for (let i = 0; i < userinfo.roles.length; i++) {
          List.push(userinfo.roles[i].fcCode)
        }
        this.$set(this.shopBeg, 'fcCodes', List.toString())
        this.$set(this.shopBeg, 'fcCode', List.toString())
      }
      //   this.shopBeg.fcCodes = List.toString()
    }
    this.init()
    var _this = this //声明一个变量指向vue实例this,保证作用域一致
    this.timer = setInterval(function () {
      _this.date = new Date()//修改数据date
    }, 1000)
  },
  methods: {
    init () {
      this.layoutInfo()
      this.getFactoryAndon()
      this.getFactoryWaitAndon()
      this.getPersonnelFacTotality()
    },
    //车间布局图
    layoutInfo () {
      let options = {
        method: 'GET',
        url: this.$api.shoplayout,
        params: this.shopBeg
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          let data = response.data
          this.length = response.data.length
          //根据工厂数量控制数据行数
          if (this.length == 1) {
            this.length2 = 19
          } else if (this.length == 2) {
            this.length2 = 9
          } else if (this.length == 3) {
            this.length2 = 6
          } else if (this.length == 4) {
            this.length2 = 4
          } else if (this.length == 5) {
            this.length2 = 3
          } else if (this.length == 6) {
            this.length2 = 3
          } else {
            this.length2 = 3
          }
          const count = this.length2
          data.forEach((item) => {
            let list = []
            //将数组处理成每三个一组 例：[[1,2,3][4,5,6]]
            let length = Math.ceil(item.shopChild.length / count)
            for (let i = 0; i < length; i++) {
              list.push(item.shopChild.slice(i * count, (i * count) + count))
            }
            item.shopChild = list
            list = []

            //将数组处理成每三个一组 例：[[1,2,3][4,5,6]]
            if (item.hasOwnProperty('sectionChild')) {
              length = Math.ceil(item.sectionChild.length / count)
              for (let i = 0; i < length; i++) {
                list.push(item.sectionChild.slice(i * count, (i * count) + count))
              }
              item.sectionChild = list
              list = []
            }

            //将数组处理成每三个一组 例：[[1,2,3][4,5,6]]
            if (item.hasOwnProperty('lineChild')) {
              length = Math.ceil(item.lineChild.length / count)
              for (let i = 0; i < length; i++) {
                list.push(item.lineChild.slice(i * count, (i * count) + count))
              }
              item.lineChild = list
              list = []
            }

            //将数组处理成每三个一组 例：[[1,2,3][4,5,6]]
            if (item.deviceChild) {
              length = Math.ceil(item.deviceChild.length / count)
              for (let i = 0; i < length; i++) {

                list.push(item.deviceChild.slice(i * count, (i * count) + count))
              }
              item.deviceChild = list
              list = []
            } else {
              item.deviceChild = []
              list = []
            }
          })
          this.shoplayoutInfo = data
        } else {
          this.$message.error('请求失败！')
        }
      })
    },
    getAll () {
      let flag = false
      let fcCode = ''
      if (this.userInfo.factoryId == 0) {
        flag = true
      }
      if (!flag) {
        let roles = this.userInfo.roles
        for (let i = 0; i < roles.length; i++) {
          fcCode += roles[i].fcCode + ','
        }
        fcCode = fcCode.substring(0, fcCode.length - 1)
      } else {
        fcCode = ''
      }
      this.activeShop = 0
      this.shopBeg.fcCode = fcCode
      this.shopBeg.shopCode = ''
      this.shopBeg.sectionCode = ''
      this.shopBeg.lineCode = ''
      this.init()
    },
    plantCodeInfo (planCode) {
      this.activeShop = planCode
      this.shopBeg.fcCode = planCode
      this.shopBeg.shopCode = ''
      this.shopBeg.sectionCode = ''
      this.shopBeg.lineCode = ''
      this.init()
    },
    shopCodeInfo (deptCode, planCode) {
      this.shopBeg.sectionCode = ''
      this.shopBeg.lineCode = ''
      this.activeShop = deptCode
      this.shopBeg.shopCode = deptCode
      this.shopBeg.fcCode = planCode
      this.init()
    },
    sectionCodeInfo (deptCode, planCode) {
      if (this.shopBeg.fcCode != undefined && this.shopBeg.fcCode != '') {
        if (this.shopBeg.fcCode != planCode) {
          this.shopBeg.shopCode = ''
        }
      }
      this.shopBeg.lineCode = ''
      this.activeShop = deptCode
      this.shopBeg.sectionCode = deptCode
      this.shopBeg.fcCode = planCode
      this.init()
    },
    lineCodeInfo (deptCode, planCode) {
      //   if (this.shopBeg.sectionCode == "") {
      //     this.shopBeg.shopCode = ""
      //   }
      if (this.shopBeg.fcCode != undefined && this.shopBeg.fcCode != '') {
        if (this.shopBeg.fcCode != planCode) {
          this.shopBeg.shopCode = ''
          this.shopBeg.sectionCode = ''
        }
      }
      this.activeShop = deptCode
      this.shopBeg.lineCode = deptCode
      this.shopBeg.fcCode = planCode
      this.init()
    },
    devCodeInfo (deptCode) {
      //   this.activeShop = deptCode
    },
    destroyed () {
      // 在页面销毁后，清除计时器
      this.clear()
    },
    // 定时刷新数据函数
    dataRefreh () {
      // 计时器正在进行中，退出函数
      if (this.intervalId != null) {
        return
      }
      // 计时器为空，操作
      this.intervalId = setInterval(() => {
        // console.log('刷新' + new Date())
        this.init() //加载数据函数
      }, 60000)
    },
    // 停止定时器
    clear () {
      clearInterval(this.intervalId) //清除计时器
      this.intervalId = null //设置为null
      this.nextPageTime = null
    },
    //滚动条横向滚动
    handleScroll (e) {
      // 0----down  1----up
      var direction = e.deltaY > 0 ? '0' : '1'
      //下面的实现的是内部元素横向滚动，前提设置好内部元素横向的滚动样式了
      if (direction === '0') {
        e.currentTarget.scrollLeft += 30
      } else {
        e.currentTarget.scrollLeft -= 30
      }
    },
    fullscreens () {
      if (this.fullscreen == '') {
        this.fullscreen = 'fullscreen',
          this.full = false
        this.deptShow = false
        let docElm = document.documentElement
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen()
        } else if (docElm.msRequestFullscreen) {
          docElm.msRequestFullscreen()
        } else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen()
        } else if (docElm.webkitRequestFullScreen) {
          docElm.webkitRequestFullScreen()
        }
      }
    },
    fullscreens2 () {
      if (this.fullscreen != '') {
        this.fullscreen = ''   //动态样式改变
        this.full = true  //全屏图标切换
        this.deptShow = true  //选择显示
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        }
      }
    },
    //跳转人员看板
    getSignNumber () {
      let array = {}
      if (this.shopBeg.fcCode != undefined && this.shopBeg.fcCode != '') {
        array['fcCode'] = this.shopBeg.fcCode
      }
      if (this.shopBeg.shopCode != undefined && this.shopBeg.shopCode != '') {
        array['shopCode'] = this.shopBeg.shopCode
      }
      this.$router.push({
        name: 'userSpectaculars',
        params: {
          signNumber: array
        }
      })
    },
    //跳转设备台账
    getDeviceStatus () {
      let array = {}
      if (this.shopBeg.fcCode != undefined && this.shopBeg.fcCode != '') {
        array['fcCode'] = this.shopBeg.fcCode
      }
      if (this.shopBeg.shopCode != undefined && this.shopBeg.shopCode != '') {
        array['shopCode'] = this.shopBeg.shopCode
      }
      if (this.shopBeg.sectionCode != undefined && this.shopBeg.sectionCode != '') {
        array['sectionCode'] = this.shopBeg.sectionCode
      }
      if (this.shopBeg.lineCode != undefined && this.shopBeg.lineCode != '') {
        array['lineCode'] = this.shopBeg.lineCode
      }
      this.$router.push({
        name: 'deviceList',
        params: {
          equiState: array
        }
      })
    },
    //跳转报警看板
    getAndonStatus () {
      let array = {}
      if (this.shopBeg.fcCode != undefined && this.shopBeg.fcCode != '') {
        array['fcCode'] = this.shopBeg.fcCode
      }
      if (this.shopBeg.shopCode != undefined && this.shopBeg.shopCode != '') {
        array['shopCode'] = this.shopBeg.shopCode
      }
      if (this.shopBeg.sectionCode != undefined && this.shopBeg.sectionCode != '') {
        array['sectionCode'] = this.shopBeg.sectionCode
      }
      if (this.shopBeg.lineCode != undefined && this.shopBeg.lineCode != '') {
        array['lineCode'] = this.shopBeg.lineCode
      }
      this.$router.push({
        name: 'acoustoSpectaculars',
        params: {
          andonState: array
        }
      })
    },
    //跳转报警看板
    getAndonTypes () {
      let array = {}
      if (this.shopBeg.fcCode != undefined && this.shopBeg.fcCode != '') {
        array['fcCode'] = this.shopBeg.fcCode
      }
      if (this.shopBeg.shopCode != undefined && this.shopBeg.shopCode != '') {
        array['shopCode'] = this.shopBeg.shopCode
      }
      if (this.shopBeg.sectionCode != undefined && this.shopBeg.sectionCode != '') {
        array['sectionCode'] = this.shopBeg.sectionCode
      }
      if (this.shopBeg.lineCode != undefined && this.shopBeg.lineCode != '') {
        array['lineCode'] = this.shopBeg.lineCode
      }
      this.$router.push({
        name: 'acoustoSpectaculars',
        params: {
          andonState: array
        }
      })
    },
    //跳转保养看板
    getPlanMain () {
      let array = {}
      if (this.shopBeg.fcCode != undefined && this.shopBeg.fcCode != '') {
        array['fcCode'] = this.shopBeg.fcCode
      }
      if (this.shopBeg.shopCode != undefined && this.shopBeg.shopCode != '') {
        array['shopCode'] = this.shopBeg.shopCode
      }
      if (this.shopBeg.sectionCode != undefined && this.shopBeg.sectionCode != '') {
        array['sectionCode'] = this.shopBeg.sectionCode
      }
      if (this.shopBeg.lineCode != undefined && this.shopBeg.lineCode != '') {
        array['lineCode'] = this.shopBeg.lineCode
      }
      this.$router.push({
        name: 'planningSpectaculars',
        params: {
          upkeepState: array
        }
      })
    },
    getFactoryAndon () {
      let params = {
        andonStatus: 'create'
      }
      if (this.shopBeg.fcCode != undefined && this.shopBeg.fcCode != '') {
        params['fcCode'] = this.shopBeg.fcCode
      }
      if (this.shopBeg.shopCode != undefined && this.shopBeg.shopCode != '') {
        params['shopCode'] = this.shopBeg.shopCode
      }
      if (this.shopBeg.sectionCode != undefined && this.shopBeg.sectionCode != '') {
        params['sectionCode'] = this.shopBeg.sectionCode
      }
      if (this.shopBeg.lineCode != undefined && this.lineSelected != '') {
        params['lineCode'] = this.shopBeg.lineCode
      }
      let options = {
        method: 'get',
        url: this.$api.factoryAndon,
        params: params
      }
      var self = this
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          if (response.data != undefined && response.data != '') {
            this.tableData = []
            var aa = response.data
            for (let i = 0; i < aa.length; i++) {
              var array = {
                andonCode: '',
                andonProbDesc: '',
                shopName: '',
                createTime: '',
                andonRespTime: '',
                countDown: ''
              }

              array.andonCode = aa[i].andonCode
              array.andonProbDesc = aa[i].andonProbDesc
              array.shopName = aa[i].shopName
              array.createTime = aa[i].createTime
              array.andonRespTime = aa[i].andonRespTime
              var createTime = new Date(aa[i].createTime).getTime()
              var arResponseSpan = aa[i].arResponseSpan
              var date = new Date().getTime()
              var countDown = (parseInt(createTime) + (parseInt(arResponseSpan) * 1000)) - parseInt(date)
              if (countDown < 0) {
                array.countDown = ''
              } else {
                array.countDown = countDown
              }
              this.tableData.push(array)
            }
          } else {
            this.tableData = []
          }
        }
      })
    },
    getFactoryWaitAndon () {
      let params = {
        andonStatus: 'wait_accept,wait_complete'
      }
      if (this.shopBeg.fcCode != undefined && this.shopBeg.fcCode != '') {
        params['fcCode'] = this.shopBeg.fcCode
      }
      if (this.shopBeg.shopCode != undefined && this.shopBeg.shopCode != '') {
        params['shopCode'] = this.shopBeg.shopCode
      }
      if (this.shopBeg.sectionCode != undefined && this.shopBeg.sectionCode != '') {
        params['sectionCode'] = this.shopBeg.sectionCode
      }
      if (this.shopBeg.lineCode != undefined && this.lineSelected != '') {
        params['lineCode'] = this.shopBeg.lineCode
      }
      let options = {
        method: 'get',
        url: this.$api.factoryAndon,
        params: params
      }
      var self = this
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          if (response.data != undefined && response.data != '') {
            this.tableWaitData = []
            var aa = response.data
            for (let i = 0; i < aa.length; i++) {
              var array = {
                andonCode: '',
                andonProbDesc: '',
                shopName: '',
                createTime: '',
                andonRespTime: '',
                countDown: ''
              }
              array.andonCode = aa[i].andonCode
              array.andonProbDesc = aa[i].andonProbDesc
              array.shopName = aa[i].shopName
              array.createTime = aa[i].createTime
              array.andonRespTime = aa[i].andonRespTime
              //开始维修时间为空就用（接单时间+到达现场时效）-当前时间
              var date = new Date().getTime()
              if (aa[i].moRepairStart == undefined || aa[i].moRepairStart == '') {
                var andonRespTime = new Date(aa[i].andonRespTime).getTime()
                var arArriveSpan = new Date(aa[i].arArriveSpan).getTime()
                var countDown = (parseInt(andonRespTime) + parseInt(arArriveSpan * 1000)) - parseInt(date)
                if (countDown < 0) {
                  array.countDown = ''
                } else {
                  array.countDown = countDown
                }
              }
              //开始维修时间不为空（开始维修时间+安灯处理时效）-当前时间
              else {
                var moRepairStart = new Date(aa[i].moRepairStart).getTime()
                var arSolveSpan = new Date(aa[i].arSolveSpan).getTime()
                var countDown = (parseInt(moRepairStart) + parseInt(arSolveSpan * 1000)) - parseInt(date)
                array.countDown = countDown
                if (countDown < 0) {
                  array.countDown = ''
                } else {
                  array.countDown = countDown
                }
              }
              this.tableWaitData.push(array)
            }
          } else {
            this.tableWaitData = []
          }
        }
      })
    },
    getPersonnelFacTotality () {
      let params = {}
      if (this.shopBeg.fcCode != undefined && this.shopBeg.fcCode != '') {
        params['fcCode'] = this.shopBeg.fcCode
      }
      if (this.shopBeg.shopCode != undefined && this.shopBeg.shopCode != '') {
        params['shopCode'] = this.shopBeg.shopCode
      }
      if (this.shopBeg.sectionCode != undefined && this.shopBeg.sectionCode != '') {
        params['sectionCode'] = this.shopBeg.sectionCode
      }
      if (this.shopBeg.lineCode != undefined && this.lineSelected != '') {
        params['lineCode'] = this.shopBeg.lineCode
      }
      let options = {
        method: 'get',
        url: this.$api.personnelFacTotality,
        params: params
      }
      var self = this
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          if (response.data) {
            self.searchData = JSON.parse(JSON.stringify(response.data))
            self.searchData.averageResponseTime = self.searchData.averageResponseTime == 0 ? 0 : (self.searchData.averageResponseTime * 60).toFixed(2)
            self.searchData.averageRepairTime = self.searchData.averageRepairTime == 0 ? 0 : (self.searchData.averageRepairTime * 60).toFixed(2)
          } else {
            this.searchData = {}
          }
        } else {
          this.searchData = {}
        }
      })
    },
    getAndonOrder () {
      let array = {}
      if (this.shopBeg.fcCode != undefined && this.shopBeg.fcCode != '') {
        array['fcCode'] = this.shopBeg.fcCode
      }
      if (this.shopBeg.shopCode != undefined && this.shopBeg.shopCode != '') {
        array['shopCode'] = this.shopBeg.shopCode
      }
      if (this.shopBeg.sectionCode != undefined && this.shopBeg.sectionCode != '') {
        array['sectionCode'] = this.shopBeg.sectionCode
      }
      if (this.shopBeg.lineCode != undefined && this.shopBeg.lineCode != '') {
        array['lineCode'] = this.shopBeg.lineCode
      }
      this.$router.push({
        name: 'andonOrderList',
        params: {
          andonOrder: array
        }
      })
    }
  },
  filters: {
    //设置一个函数来进行过滤
    formaDate: function (value) {
      //创建一个时间日期对象
      var date = new Date()

      var year = date.getFullYear()      //存储年
      var month = padaDate(date.getMonth() + 1)    //存储月份
      var day = padaDate(date.getDate())         //存储日期
      var hours = padaDate(date.getHours())      //存储时
      var minutes = padaDate(date.getMinutes())  //存储分
      var seconds = padaDate(date.getSeconds())  //存储秒
      //返回格式化后的日期
      return year + '-' + month + '-' + day + '-' + hours + ':' + minutes + ':' + seconds
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)//在vue实例销毁钱，清除我们的定时器
    }
  },

  destroyed () {
    // 在页面销毁后，清除计时器
    this.clear()
  }
}
</script>

<style lang="scss" scoped>
.el-container .el-container .el-main .pageBox > div {
    height: max-content;
}

.background {
    zoom: 1;
    width: 100%;
    height: 100%;
    text-align: left;
    background-size: cover;
    -o-background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center 0;
    -webkit-background-size: cover;
}

.topTit {
    color: #fff;
    font-size: 21px;
    margin-top: -2.5vw;
    // transform: translateY(-40px);
}

.topTime {
    right: -2vw;
    top: 2.8vw;
    color: #fff;
    display: flex;
    font-size: 13px;
    text-align: right;
    position: absolute;
    margin-right: 10px;
    align-items: center;
    transform: translate(-29px, -31px);
}

.shopoVerall {
    width: 77%;
    height: 100%;
    margin-left: 1vw;
    align-items: center;
    background-color: #00589acc;
    border: solid 1px rgba(255, 255, 255, 0.61);

    .shopTit {
        font-size: 18px;
        margin-top: -44px;
        color: #5bfcf4;
        position: absolute;
        font-weight: bold;
        margin-left: 20px;
    }
}

.explain {
    display: flex;
    font-size: 13px;

    div {
        display: flex;
        align-items: center;
        margin-right: 1vw;

        span {
            margin-left: 5px;
        }
    }
}

.shoplayout {
    width: 100%;
    height: 91%;
    display: flex;
    overflow: auto;
    flex-wrap: wrap;
    align-items: center;
}

.layout {
    display: flex;
    margin-bottom: 5px;

    p {
        font-size: 18px;
        color: #5bfcf4;
        font-weight: bold;
        margin-bottom: 5px;
    }
}

.shopBor {
    border-bottom: dashed 1px #1acacc;
}

.plantName {
    width: 50px;
    height: 35px;
    color: #fff;
    display: flex;
    font-size: 19px;
    overflow: hidden;
    font-weight: bold;
    margin-left: 1.5vw;
    align-items: center;
    justify-content: center;
    background-color: #1e4480;
}

.shopInfo {
    display: flex;
    font-size: 13px;
    height: 100%;
    align-items: center;
    overflow-x: auto;
    overflow-y: hidden;

    div {
        margin-bottom: 2px;
        margin-right: 3px;
    }
}

.shopName {
    width: 6vw;
    color: #fff;
    overflow: hidden;
    white-space: nowrap;
    padding: 2px 4px 4px 4px;
    background-color: #1e4480;
}

.shopBorder {
    border: solid 1px #5bfcf4;
}

::-webkit-scrollbar {
    display: none;
}

.echarState {
    width: 20%;
    margin-left: 0.8vw;
    // margin-right: 20px;
    background-color: #00589acc;
    border: solid 1px rgba(255, 255, 255, 0.61);
}

.lineState {
    font-size: 18px;
    margin-left: 25px;
    color: #5bfcf4;
    position: absolute;
    font-weight: bold;
    margin-top: 10px;
}

.echarInfo {
    width: 97.8%;
    height: 25vh;
    display: flex;
    margin-top: 1vh;
    margin-left: 1vw;
    margin-bottom: 1vh;
    background-color: #00589acc;
    border: solid 1px rgba(255, 255, 255, 0.61);

    .vessel {
        flex: 1;
        width: 100%;
        height: 100%;

        .TItexplain {
            height: 23%;
            position: relative;

            img {
                width: 95%;
                height: 35px;
                margin: 5px;
            }

            .Signed {
                font-size: 18px;
                margin-left: 20px;
                color: #5bfcf4;
                font-weight: bold;
                margin-top: -40px;
                position: absolute;
            }
        }

        .signNumber,
        .equiState,
        .andonState,
        .andonType,
        .upkeepState {
            width: 96%;
            height: 77%;
            margin-left: 5px;
            // background-color: red;
        }
    }
}

.repair {
    display: flex;
    height: 3vh;
    width: 100%;
    align-items: center;

    div {
        flex: 1;
        text-align: center;
        color: #fff;
        /*overflow:hidden;
                text-overflow:ellipsis;
                white-space:nowrap;*/
        font-size: 0.9vw;
    }
}

.mouse {
    cursor: pointer;
}

.fullscreen {
    top: 0;
    left: 0;
    z-index: 9999;
    position: absolute;
}

.shopBgColor1 {
    background-color: #5491f8;
}

.shopBgColor2 {
    background-color: #2bbea3;
}

.shopBgColor3 {
    background-color: rgb(255, 0, 0);
}

.shopBgColor4 {
    background-color: #b7b5bc;
}

.shopBgColor5 {
    background-color: #c5ae76;
}

.shopHei3 {
    height: 5vw;
}

.shopHei4 {
    height: 11.9vh;
}

.shopHei6 {
    height: 17.5vh;
}

.shopHei9 {
    height: 26.2vh;
}

// .shopHei19 {
//     height: 10.3vh;
// }

.equiinfo ::v-deep th {
    text-align: center;
    border-right: none;
    border-bottom: 0px !important; /*删除表头下横线*/
}

.equiinfo ::v-deep .el-table,
.el-table__expanded-cell {
    background-color: transparent !important;
}

::v-deep .el-table {
    .cell.el-tooltip {
        width: auto !important;
    }
}

/* //透明化行、单元格,删除表头下横线 */
.equiinfo ::v-deep tr,
.equiinfo ::v-deep td {
    text-align: center;
    background: #1439391c !important;
    color: #fff;
    border-right: none;
    // border-bottom: 1px dashed #46d4ff; /*下横线*/
}

/* //hover时样式 */
.equiinfo ::v-deep .el-table tbody tr:hover > td {
    background-color: #367f7f78 !important;
}

/* // 表格内容(有用) */
.equiinfo ::v-deep .el-table__row {
    background: #1439391c !important;
    color: #46d4ff;
}

.el-table--border::after ::v-deep,
.el-table--group::after ::v-deep,
.el-table::before ::v-deep {
    background-color: transparent;
}

// 滚动条样式
::-webkit-scrollbar {
    width: 4px !important;
    /*height: 4px;*/
}

::-webkit-scrollbar-thumb {
    border-radius: 10px !important;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.068) !important;
    background: rgba(0, 0, 0, 0.068) !important;
}

::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.068) !important;
    border-radius: 0 !important;
    background: rgba(0, 0, 0, 0.068) !important;
}
</style>
